export default [{
    path: '/help',
    component: ()=> import("@/views/Help"),
    meta:{
        title:"帮助中心"
    },
    children:[]
}]